var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "chevron-up_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.293 8.293a1 1 0 011.414 0l6 6a1 1 0 01-1.414 1.414L12 10.414l-5.293 5.293a1 1 0 01-1.414-1.414l6-6z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTExLjI5MjkgOC4yOTI4OUMxMS42ODM0IDcuOTAyMzcgMTIuMzE2NiA3LjkwMjM3IDEyLjcwNzEgOC4yOTI4OUwxOC43MDcxIDE0LjI5MjlDMTkuMDk3NiAxNC42ODM0IDE5LjA5NzYgMTUuMzE2NiAxOC43MDcxIDE1LjcwNzFDMTguMzE2NiAxNi4wOTc2IDE3LjY4MzQgMTYuMDk3NiAxNy4yOTI5IDE1LjcwNzFMMTIgMTAuNDE0Mkw2LjcwNzExIDE1LjcwNzFDNi4zMTY1OCAxNi4wOTc2IDUuNjgzNDIgMTYuMDk3NiA1LjI5Mjg5IDE1LjcwNzFDNC45MDIzNyAxNS4zMTY2IDQuOTAyMzcgMTQuNjgzNCA1LjI5Mjg5IDE0LjI5MjlMMTEuMjkyOSA4LjI5Mjg5WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";
export { SvgChevronUp as ReactComponent };